import React, {useContext} from 'react';
import {AuthContext} from '../common/context/authContext';
import '../../assests/css/apierror.scss';

export default function ApiError() {

    const {setUserToken} = useContext(AuthContext);

    const redirect = new URL(location.href).searchParams.get('redirect');

    return (
        <div className="api-error-container">
            <div>
                Session expired. Please click the refresh button below to start
                a new session.
            </div>
            <div className="api-error-control"
                onClick={()=> setUserToken(redirect? redirect: '/')}>
                Refresh
            </div>
        </div>
    );

}